/*
 * @Author: randy
 * @Date: 2020-08-01 14:54:46
 * @LastEditTime: 2020-08-11 13:22:40
 * @Description: 窗口大小mixin
 */

const { body } = document;
const WIDTH = 992; // mobile
const BROKEN = 1200; // pad

import { mapMutations } from "vuex";
import { SET_MOBILE, SET_COLLAPSED, SET_PAD } from "@/store/types";
import _ from "lodash";

export default {
  beforeMount() {
    window.addEventListener("resize", this.$_resizeHandler);
  },
  mounted() {
    this.handleDevice();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.$_resizeHandler);
  },
  methods: {
    ...mapMutations({
      setMobile: SET_MOBILE,
      setPad: SET_PAD,
      setCollapsed: SET_COLLAPSED
    }),
    $_resizeHandler: _.throttle(function() {
      this.handleDevice();
    }, 600),
    $_isMobile() {
      const rect = body.getBoundingClientRect();
      return rect.width - 1 < WIDTH;
    },
    $_isPad() {
      const rect = body.getBoundingClientRect();
      return rect.width - 1 > WIDTH && rect.width - 1 < BROKEN;
    },
    handleDevice() {
      const isMobile = this.$_isMobile();
      const isPad = this.$_isPad();
      this.setMobile(isMobile);
      this.setPad(isPad);
      if (isMobile) {
        this.setCollapsed(false);
      } else if (isPad) {
        this.setCollapsed(true);
      } else {
        this.setCollapsed(false);
      }
    }
  }
};
